export default __webpack_public_path__ + "images/1e25aa3b884128d1cdfb3708a15a5803.svg";